import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import Card from '../../../components/Card';
import Chip from '../../../components/Chip';
import FaIcon from '../../../components/Icons/FaIcon';
import Text from '../../../components/Text';
import { classNames } from '../../../helpers/classNames';
import { fetchLawyer } from '../../../services/lawyerService';
import LawyerType from '../../../types/LawyerType';
import LawyerCalendar from './calendar';
import LawyerCover from './cover';
import LawyerPrestation from './prestations';
import styles from './style.module.scss';

function Lawyer() {
    const { lawyerId = '' } = useParams();

    const { data, isPending } = useQuery({
        queryKey: ['lawyer', lawyerId],
        queryFn: async () => {
            if (lawyerId.length === 0) {
                return null;
            }
            const { data } = await fetchLawyer(lawyerId);
            return data;
        },
    });

    const lawyer: LawyerType = data;

    if (isPending) return <div>Loading...</div>; // loading page

    return (
        <div className={classNames([styles.lawyerDetails])}>
            <LawyerCover lawyer={lawyer} />

            <div className={styles.body}>
                <div className={styles.bodyInfo}>
                    {lawyer.specialities.length > 0 && (
                        <div
                            className={classNames([
                                styles.bodySpeciality,
                                styles.bodyContainer,
                            ])}
                        >
                            {lawyer.specialities.map((spe) => (
                                <Chip key={spe.id}>{spe.name}</Chip>
                            ))}
                        </div>
                    )}
                    <div
                        className={classNames([
                            styles.bodyContact,
                            styles.bodyContainer,
                        ])}
                    >
                        <div>
                            <span className={styles.icon}>
                                <FaIcon>fa-map-location-dot</FaIcon>
                                <span>Adresse</span>
                            </span>
                            <span>
                                <Text>
                                    {lawyer.buildingNumber} {lawyer.streetName}
                                </Text>
                            </span>
                            <span>
                                {lawyer.city} {lawyer.zipCode} {lawyer.country}
                            </span>
                        </div>
                        <div>
                            <span className={styles.icon}>
                                <FaIcon>fa-phone</FaIcon>
                                <span>Téléphone</span>
                            </span>
                            <span>
                                <Text>{lawyer.phone}</Text>
                            </span>
                        </div>
                        <div>
                            <span className={styles.icon}>
                                <FaIcon>fa-envelope</FaIcon>
                                <span>Mail</span>
                            </span>
                            <span>
                                <Text>{lawyer.email}</Text>
                            </span>
                        </div>
                    </div>
                    <Card
                        className={classNames([
                            styles.bodyDescription,
                            styles.bodyContainer,
                        ])}
                    >
                        <h3>Présentation : </h3>
                        <p>
                            <Text>
                                {lawyer.description ||
                                    `Avocat au Barreau de ${lawyer.lawyerBar}, Maître ${lawyer.lastName} exerce au ${lawyer.address} et propose des services juridiques adaptés aux besoins de ses clients, en les accompagnant dans différentes démarches juridiques.`}
                            </Text>
                        </p>
                    </Card>
                    <Card
                        className={classNames([
                            styles.bodyMeeting,
                            styles.bodyContainer,
                        ])}
                    >
                        <h3>Horaires : </h3>

                        <div className={styles.calendar}>
                            <LawyerCalendar lawyer={lawyer} />
                        </div>
                    </Card>
                    <Card
                        className={classNames([
                            styles.bodyPrice,
                            styles.bodyContainer,
                        ])}
                    >
                        <h3>Tarif : </h3>
                        <LawyerPrestation prestations={lawyer.prestations} />
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default Lawyer;
